import PropTypes from "prop-types";

// material-ui
import { Divider, List, Typography } from "@mui/material";

// project imports
import NavItem from "../NavItem";

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
  // Menu Items
  const items = item.children?.map((menu) => {
    switch (menu.type) {
      case "item":
        return <NavItem key={menu.id} item={menu} level={1} />;
      default:
        return (
          <Typography key={menu.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return (
    <>
      <List
        subheader={
          item.title && (
            <Typography
              variant="caption"
              sx={{
                fontSize: "0.875rem",
                fontWeight: 500,
                color: "#212121",
                padding: "6px",
                textTransform: "capitalize",
                marginTop: "10px",
              }}
              display="block"
              gutterBottom
            >
              {item.title}
              {item.caption && (
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "0.6875rem",
                    fontWeight: 500,
                    color: "#A7A7A7",
                    textTransform: "capitalize",
                  }}
                  display="block"
                  gutterBottom
                >
                  {item.caption}
                </Typography>
              )}
            </Typography>
          )
        }
      >
        {items}
      </List>

      {/* group divider */}
      <Divider sx={{ mt: 0.25, mb: 1.25 }} />
    </>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object,
};

export default NavGroup;
